import React from 'react';
import type { ProviderFeeOperation } from '../../../types';
import Modal from '../../ui/Modal';
import ProviderFeeFormFields from './ProviderFeeFormFields';
import type { EditableRow, SupportedByKeyMap } from './providerFeesTypes';

export default function ProviderFeeAddModal(props: {
  isOpen: boolean;
  onClose: () => void;
  draftRow: EditableRow;
  setDraftRow: React.Dispatch<React.SetStateAction<EditableRow>>;
  providerOptions: string[];
  supportedByKey: SupportedByKeyMap;
  ensureSupportedMethods: (providerRaw: string, operationRaw: ProviderFeeOperation) => Promise<void>;
  onSubmit: () => void;
  isSubmitting: boolean;
}) {
  const {
    isOpen,
    onClose,
    draftRow,
    setDraftRow,
    providerOptions,
    supportedByKey,
    ensureSupportedMethods,
    onSubmit,
    isSubmitting,
  } = props;

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Add provider fee"
      subtitle="Configure provider, operation, coin/network, and fee (%)."
      variant="form"
      size="lg"
      primaryAction={{
        label: 'Add',
        onClick: onSubmit,
        loading: isSubmitting,
        disabled: !(draftRow.provider || '').trim() || isSubmitting,
      }}
      secondaryAction={{
        label: 'Cancel',
        onClick: onClose,
      }}
    >
      <ProviderFeeFormFields
        draftRow={draftRow}
        setDraftRow={setDraftRow}
        providerOptions={providerOptions}
        supportedByKey={supportedByKey}
        ensureSupportedMethods={ensureSupportedMethods}
      />
    </Modal>
  );
}

